import { Paper, Typography } from '@mui/material';
import moment from 'moment';
import React from 'react';
import { useHistory } from 'react-router-dom';
import Image from '../../utils/assetHelper';
import routes from '../../../../Utils/routes';
import { useStyles } from '../../styles';

const RegisterEvent: React.FunctionComponent<any> = ({ data }) => {
  console.log(data, "datadatadatadatadatadata12345678");

  const classes = useStyles();
  const navigate = useHistory();
  // console.log('data675', data);

  return (
    data && (
      <div>
        <Typography className={classes.registeredCardKey}>{`${moment(data?.sessionStartDate).format('Do MMMM YYYY')}`}</Typography>
        <Paper
          className={`${classes.registeredEvents} scrollbar-cusgray`}
          onClick={() => {
            navigate.push(`${routes.eventDetail}/${data?.Id}`, { state: { registered: data?.Id, breadCrumbs: data?.title } });
          }}
        >
          <div>
            <Typography className={classes.registerCardText} fontWeight={'400'}>
              {`${moment.utc(`${data?.sessionStartTime}`, "'HH:mm:ss.SSS[Z]").format('hh:mm A')} - ${moment
                .utc(`${data?.sessionEndTime}`, "'HH:mm:ss.SSS[Z]")
                .format('hh:mm A')}`}
            </Typography>
            <Typography className={classes.registerCardText} fontWeight={'500'} lineHeight={'19px'} margin={'4px 0px'}>
              {data?.sessionName || '-'}
            </Typography>
            <Typography className={classes.registerCardText} fontWeight={'600'}>
              {data?.location}
            </Typography>
          </div>
          <img alt="banner" className={classes.registeredEventsBanner} src={data?.coverImageURL ? data?.coverImageURL : Image.Images.EventCardCoverImage} />
        </Paper>
      </div>
    )
  );
};

export default RegisterEvent;
